<template>
    <div class="home d-flex flex-column justify-content-start">
        <div class="row h-100">
            <div class="col-md-9 h-100 overflow-auto">
                <dashboard-feed-top
                    :filterButtons="buttons"
                    :feedFilter="feedFilter"
                    :locked="showFirstTasks"
                    @filterChanged="feedFilter = $event">
                </dashboard-feed-top>

                <dashboard-starting-tasks 
                    v-if="showFirstTasks" 
                    v-on:forceSkipTasks="forceSkipTasks" 
                    v-on:skipTasksForNow="skipTasksForNow">
                </dashboard-starting-tasks>
                
                <dashboard-feed 
                    v-if="showFeed" 
                    :cards="feedCards" 
                    :filter="feedFilter">
                </dashboard-feed>
            </div>

            <div class="col-md-3">
                <dashboard-side-panel></dashboard-side-panel>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import DashboardFeedTop from '../dashboard/FeedTop'
import DashboardFeed from '../dashboard/Feed'
import DashboardStartingTasks from '../dashboard/StratingTasks'
import DashboardSidePanel from '../dashboard/SidePanel'

export default {
    data() {
        return {
            skipFirstTasks: false,
            showFirstTasks: false,
            showFeed: true,
            gotCompanySettings: false,
            feedFilter: 'today',
            buttons: [
                {
                    label: 'Today',
                    icon: 'ico-calendar',
                    term: 'today'
                }
            ],
            feedCards: [
                {
                    category: 'today',
                    type: 'newota',
                    otaId: 1,
                    visible: false
                },
                {
                    category: 'today',
                    type: 'news',
                    title: 'Qatar: Portugal entre os países isentos de Visa.',
                    subTitle: 'Medida visa atrair mais turistas ao país e tem efeito imediato.',
                    date: '16 DE AGOSTO DE 2017, POR PUBLITURIS',
                    image: 'https://img.rt.com/files/2017.06/original/5935126ec36188cb648b459b.jpg',
                    visible: false
                },
                {
                    category: 'performance',
                    type: 'occupancyreport',
                    visible: false
                },
                {
                    category: 'today',
                    type: 'multi',
                    nrAlerts: 15,
                    nrPickups: 0,
                    nrBookings: 5,
                    visible: false
                },
                {
                    category: 'performance',
                    type: 'departures',
                    visible: true
                },
                {
                    category: 'today',
                    type: 'weather',
                    label: 'Sunny Days',
                    overview: {
                        temperature: 30,
                        percipitation: 0,
                        humidity: 27,
                        windSpeed: 13,
                    },
                    visible: true
                },
                {
                    category: 'sales',
                    type: 'salesdaily',
                    visible: false
                },
                {
                    category: 'checkins',
                    type: 'missedcheckins',
                    visible: false
                },
                {
                    category: 'performance',
                    type: 'occupancy',
                    productName: 'Caves & Coastline',
                    date: 'Tomorrow, 10:30',
                    percentAvaliable: '20',
                    ticketRemaining: '10',
                    visible: false
                }
            ]
        }
    },
    created() {
        this.showStartingTasks();

        // Redires user if needed
        if (this.accessPermissionFilter(['viewer'])) {
            this.$router.push({name: 'calendar'});
        }
    },
    methods:{
        ...mapActions([
            'initSettings'
        ]),
        forceSkipTasks() {
            this.skipFirstTasks = true;
        },
        async showStartingTasks() {
            let vm = this;

            // Checks if user pressed "Skip for now"
            this.initSettings().then(() => {
                vm.showFeed = true;
                vm.showFirstTasks = false;
            })
            .catch(error => {
                vm.$toasted.error(error);
            });
        },
        skipTasksForNow() {
            this.showStartingTasks();
        }
    },
    components: {
        DashboardFeedTop,
        DashboardFeed,
        DashboardSidePanel,
        DashboardStartingTasks
    }
}
</script>



// WEBPACK FOOTER //
// Home.vue?38ecac8c